import { render } from "./MobileNoVerification.vue?vue&type=template&id=4310fd40&scoped=true"
import script from "./MobileNoVerification.vue?vue&type=script&lang=js"
export * from "./MobileNoVerification.vue?vue&type=script&lang=js"

import "./MobileNoVerification.vue?vue&type=style&index=0&id=4310fd40&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4310fd40"]])

export default __exports__